import axios from 'axios';

const axiosInstance = axios.create({
   baseURL: 'https://serene-meadow-66121-9d6741cd6016.herokuapp.com', // Replace with your backend host
  // baseURL: 'http://localhost:8080', // Replace with your backend host
});

export default axiosInstance;